import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';
import { FreeBetMaxPayoutPopUp, gameConfigStore, getAmountWithCurrency } from '@pascal/pascal-core';
import GameChart from './chartPart';
import Parabola from './chartParabola';
import { CurrentOdd } from '../currentOdd';
import { RoundFinPopUp, Timer } from '../index';
import { chartStore } from '../../../store/chartStore';
import { autoPlayBetStore, doBetStore } from '../../../store';
import { globalTranslationKeys } from '../../../enums';
import { AutoPlayStopPopUp } from '../autoPlayStopPopUp';
import { MaxWinNotification } from '../popUps/maxWinNotification';
import { WinNotification } from '../currentOdd/winNotifiCation';
import crashLogo from '../../../assets/images/crash-logo.png';
import { brandedGameIds } from '../../../enums/brandedPartners';
import padisahCrash from '../../../assets/images/crash-logo-padisah.png';
import ecuabetCrash from '../../../assets/images/crash-logo-ecuabet.png';
import betofficeCrash from '../../../assets/images/crash-logo-betoffice.png';
import galabetCrash from '../../../assets/images/crash-logo-galabet.png';

export const Chart = observer(({ t }) => {
  const { roundId } = roundInfoStore;
  const { isRoundFinish } = chartStore;
  const { gameId, partnerId } = gameConfigStore;
  const {
    isAutoBetAccepted,
    currentBetAmount,
    isCurrentBetAmountShow,
    stopAutoPlayPopUp: { isShow, stopTypeText, stopTypeValue },
  } = autoPlayBetStore;

  const winData = doBetStore.winPopUpsData;

  const brandedGameTypeLogos = useMemo(
    () => ({
      [brandedGameIds.padisah]: padisahCrash,
      [brandedGameIds.ecuabet]: ecuabetCrash,
      [brandedGameIds.betoffice]: betofficeCrash,
      [brandedGameIds.betofficeByPartnerId]: betofficeCrash,
      [brandedGameIds.galaBetByPartnerId]: galabetCrash,
    }),
    []
  );

  return (
    <div className='crash-game'>
      <div className='crash-game-holder animate-chart'>
        <div className='crash-logo-holder'>
          <div className='crash-logo-glow blue' />
          <div className='crash-logo-glow pink' />
          <div className='crash-logo-text'>
            <img
              src={brandedGameTypeLogos[gameId] || brandedGameTypeLogos[partnerId] || crashLogo}
              alt=''
            />
          </div>
          <div className='crash-logo-icons-holder'>
            {!brandedGameTypeLogos[gameId] && !brandedGameTypeLogos[partnerId] && (
              <>
                <i className='crash-icon crash-icon-cross ui-lib-cross' />
                <i className='crash-icon crash-icon-circle ui-lib-circle' />
                <i className='crash-icon crash-icon-logo-triangle ui-lib-logo-triangle' />
              </>
            )}
            <i className='crash-icon crash-icon-logo-lines ui-lib-logo-lines' />
            <i className='crash-icon crash-icon-circle ui-lib-circle' />
            <i className='crash-icon crash-icon-cross ui-lib-cross' />
          </div>
        </div>
        <div className='crash-game-holder-inside'>
          <div className='crash-game-info'>
            <div className='crash-game-info-inside'>
              <div className='crash-game-info-item'>
                <p>
                  {t(globalTranslationKeys.RoundId)}: {roundId}
                </p>
              </div>
              <div className='crash-game-info-item'>
                {isAutoBetAccepted && !!+currentBetAmount && isCurrentBetAmountShow && (
                  <p title={t(globalTranslationKeys.CurrentBet)}>
                    {t(globalTranslationKeys.CurrentBet)}
                    <span>
                      {` ${getAmountWithCurrency({
                        amount: currentBetAmount,
                      })}`}
                    </span>
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className='crash-game-side'>
            {!!winData.length && <WinNotification winData={winData} t={t} />}
            <MaxWinNotification t={t} />
            <FreeBetMaxPayoutPopUp />
            <div className='crash-game-side-inside'>
              <CurrentOdd />
              <Parabola />
              <GameChart key={roundId} />
            </div>
          </div>
        </div>
        {isShow && <AutoPlayStopPopUp t={t} text={stopTypeText} value={stopTypeValue} />}
        <Timer />

        {isRoundFinish && <RoundFinPopUp />}
      </div>
    </div>
  );
});
